import React from "react";
import logo from "../../assets/Image/logo.svg";
import ICONA_LIGHT1 from "../../assets/Image/ICONA_LIGHT1.svg";
import DARK_ICONA2 from "../../assets/Image/DARK_ICONA2.svg";
import ONBOARDINGICONA from "../../assets/Image/ONBOARDINGICONA.svg";
import RIFERIMENTIICONA from "../../assets/Image/RIFERIMENTIICONA.svg";
import formazione from '../../assets/Image/FORMAZIONE_ICONA.svg'

import { Link } from "react-router-dom";
import Group756 from "../../assets/Image/Group756.svg";
import Group824 from "../../assets/Image/Group824.svg";
import Group758 from "../../assets/Image/Group758.svg";
import { useState, useEffect } from "react";
import logoipad from "../../assets/Image/logo-ipad.svg";
import LOGOUT_ICONA from "../../assets/Image/LOGOUT_ICONA.svg";
import terms from "../../assets/Image/T&C_ICONA.svg";
import {
  getLocalStoarge,
  removeLocalStoarge,
  removeLocalStoarge1,
  setLocalStoarge,
  Logout,
} from "../common/allfunction";
import { useTranslation } from "react-i18next";
import { AiOutlineCaretLeft } from "react-icons/ai";

function SidebarProfile() {
  const [activebg, setActivebg] = useState("active");
  const [theme, setTheme] = useState("light");
  const [toggleStatus, setToggleStatus] = useState(true);
  const [t, i18n] = useTranslation("common");
  const handleTranslationLang = () => {
    let lang = getLocalStoarge("langauage");
    if (lang) {
      i18n.changeLanguage(lang);
    }
  };
  const toggleTheme = () => {
    setTheme(theme === "light" ? "dark" : "light");
    setToggleStatus(theme === "light" ? true : false);
    setLocalStoarge(
      "theme",
      JSON.stringify(theme === "light" ? "dark" : "light")
    );
  };

  useEffect(() => {
    document.body.className = theme;
    handleTranslationLang();
  }, [theme]);
  useEffect(() => {
    let theme1 = getLocalStoarge("theme");
    theme1 = theme1 ? JSON.parse(theme1) : "";
    setTheme(theme1);
    if (theme1) {
      setToggleStatus(theme1 === "light" ? false : true);
    } else {
      setTheme("light");
      setToggleStatus(false);
    }
    setActivebg(pageName);
  }, []);

  const path = window.location.pathname;
  const pageName = path.substring(path.lastIndexOf("/") + 1);

  const removeToken = () => {
    // export function from module
    const logout = Logout();
    if (logout) {
      window.location.href = `/app/login/${localStorage.getItem('dynamic_id')}`;
      // removeLocalStoarge(['summaryPageGuide','pageGuide']);
      removeLocalStoarge1();


    } else {
      console.log("something was wrong");
    }
  };
  return (
    <>
      <div className="left-dashboard">
        <div className="w-100">
          <Link to="/dashboard">
            {/* <img
              src={logo}
              className="img-fluid logo_common ipd-logo-n"
              alt="logo"
            />
            <img
              src={logoipad}
              className="img-fluid logo_common vison-tab"
              alt="logo"
            /> */}
            <div className="logo-sidebar ipd-logo-n"></div>
            <div className="logo-sidebar ipad-logo-show vison-tab"></div>
          </Link>
          <Link to="/dashboard">
            <div className="activ-tab">
              <span className="name_left">
                <AiOutlineCaretLeft />
                <span className="ipad-textn">
                  {t("user.sidebarProfile.dashboard")}
                </span>
              </span>
            </div>
          </Link>
          <div className="navigate manageside-bar">
            <ul>
              <li className={activebg == "steps" ? "active" : ""}>
                <Link to="/steps">
                  {/* <img src={ONBOARDINGICONA} alt="icon" /> */}
                  <div className="dash-icon home-stepicon"></div>
                  <span className="ipad-textn p-lefts">
                    {t("user.sidebarProfile.steps")}
                  </span>
                </Link>
              </li>
              <li className={activebg == "privacy" ? "active" : ""}>
                <Link to="/privacy">
                  {/* <img src={Group758} alt="icon" /> */}
                  <div className="dash-icon privacy-icon"></div>
                  <span className="ipad-textn p-lefts">
                    {t("user.sidebarProfile.privacy")}
                  </span>
                </Link>
              </li>
              <li className={activebg == "terms" ? "active" : ""}>
                <Link to="/terms">
                  {/* <img src={terms} alt="icon" /> */}
                  <div className="dash-icon terms-icon"></div>
                  <span className="ipad-textn p-lefts">
                    {t("user.sidebarProfile.t&c")}
                  </span>
                </Link>
              </li>

              <li className={activebg == "referement-science" ? "active" : ""}>
                <Link to="/referement-science">
                  {" "}
                  {/* <img src={RIFERIMENTIICONA} alt="icon" /> */}
                  <div className="dash-icon References-icon"></div>
                  <span className="ipad-textn p-lefts">
                    {t("user.sidebarProfile.referments")}
                  </span>
                </Link>
              </li>

              {/* <li className={activebg == "brainwellness-science" ? "active" : ""}>
                <Link to="/brainwellness-science"> 
                   <img src={Group756} alt="icon" /> 
                  <span className="ipad-textn p-lefts"> 
                     {t("user.sidebar.brain_wellness_science")} 
                   </span>
                </Link>
              </li> */}

              <li className={activebg == "training" ? "active" : ""}>
                <Link to="/training">
                  <img src={formazione} className="" alt="icon" />
                  <span className="ipad-textn p-lefts">
                    {t("user.sidebar.training")}
                  </span>             

                </Link>
              </li>

              <li className={activebg == "faq" ? "active" : ""}>
                <Link to="/faq">
                  {/* <img src={Group824} alt="icon" /> */}
                  <div className="dash-icon faq-icon"></div>
                  <span className="ipad-textn p-lefts">
                    {t("user.sidebarProfile.FAQ")}
                  </span>
                </Link>
              </li>

              <li className={activebg == "profile" ? "active" : ""}>
                <Link to="/profile">
                  {/* <img src={Group756} alt="icon" /> */}
                  <div className="dash-icon setting-icon"></div>
                  <span className="ipad-textn p-lefts">
                    {t("user.sidebarProfile.profile")}
                  </span>
                </Link>
              </li>
              <li onClick={removeToken} className="cursor">
                <Link to={`/login/${localStorage.getItem('dynamic_id')}`}>
                  <img src={LOGOUT_ICONA} alt="icon" />
                  {/* <div className="dash-icon logout-icon"> */}
                  <span className="ipad-textn p-lefts">
                    {t("user.sidebarProfile.logout")}
                  </span>
                  {/* </div> */}
                </Link>
              </li>
            </ul>
          </div>

        </div>
        <div className="ali-bottom">
          <div className="bot-set n-mobi">
            {toggleStatus == true && (
              <input
                type="checkbox"
                className="checkbox"
                id="checkbox"
                checked
                onChange={toggleTheme}
              />
            )}
            {toggleStatus == false && (
              <input
                type="checkbox"
                className="checkbox"
                id="checkbox"
                onChange={toggleTheme}
              />
            )}
            <label htmlFor="checkbox" className="label">
              <div className="icco">
                <img src={ICONA_LIGHT1} className="img-fluid" alt="logo" />
              </div>
              <div className="moon">
                <img src={DARK_ICONA2} className="img-fluid" alt="logo" />
              </div>
              <div className="anim-dari">
                <div className="ball"></div>
                <div className="light"></div>
                <div className="dark"></div>
              </div>
            </label>
          </div>
        </div>
      </div>
    </>
  );
}

export default SidebarProfile;
